<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Demand Item {{ demandItemId }}</h4>
      <p>View demand item information, history, and expanded rows.</p>
    </div>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()">
  <form novalidate class="form-horizontal mb-5">
    <div class="landing-main" *ngIf="lineage">
      <fieldset class="fieldsetstyle">
        <div class="top-panel" style="height: fit-content">
          <ul class="list-container col-md-10">
            <li class="flex-box mb-3" *ngIf="lineage.ServiceTreeId">
              <div class="col-md-2 label">Service Tree Id</div>
              <div class="col-md-10 value">{{ lineage.ServiceTreeId }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="lineage.Type">
              <div class="col-md-2 label">Type</div>
              <div class="col-md-10 value">{{ lineage.Type }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="lineage.Name">
              <div class="col-md-2 label">Blueprint Name</div>
              <div class="col-md-10 value">{{ lineage.Name }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="lineage.Region">
              <div class="col-md-2 label">Region</div>
              <div class="col-md-10 value">{{ lineage.Region }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="lineage.Resource">
              <div class="col-md-2 label">Resource</div>
              <div class="col-md-10 value">{{ lineage.Resource }}</div>
            </li>
          </ul>
        </div>
      </fieldset>

      <fieldset>
        <h5>Tables</h5>
        <hr />

        <div class="card mb-4">
          <div class="card-header">
            <span class="bold-font">Expanded Items</span>
          </div>
          <div class="card-block p-3">
            <ag-grid-angular
              *ngIf="expandedGridOptions"
              id="ExpandedGrid"
              style="width: 100%; min-height: 120px"
              class="ag-theme-balham"
              [gridOptions]="expandedGridOptions"
              [rowData]="expandedRowData"
              [pagination]="true"
              [domLayout]="'autoHeight'"
              (gridReady)="onExpandedGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>

        <div class="card mb-4" *ngIf="gridOptions">
          <div class="card-header">
            <span class="bold-font">History</span>
          </div>
          <div class="card-block p-3">
            <ag-grid-angular
              *ngIf="gridOptions"
              id="HistoryGrid"
              style="width: 100%; min-height: 120px"
              class="ag-theme-balham"
              [gridOptions]="gridOptions"
              [rowData]="rowData"
              [pagination]="true"
              [domLayout]="'autoHeight'"
              (gridReady)="onGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>
      </fieldset>
    </div>

    <div *ngIf="errorMessage" class="container container-content container-max-width">
      <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
    </div>
  </form>
</div>
